module.exports = __webpack_public_path__ + "media/images/partners/antiphishing-6598c4c69c8b0941720cd24cb1d0995c.png";